import { List, Tooltip, Image, Spin, Collapse, Row, Col, Divider } from 'antd';
import React, { Dispatch } from 'react';
import { Metreage, ShoppingCartItem } from '../../store/ducks/shoppingCart/types';
import { maskCamelCase, maskCurrency } from '../../utils/masks';
import { LoadingOutlined, DeleteFilled } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Action } from 'typesafe-actions';
import { addItemRequest, deleteItemRequest } from '../../store/ducks/shoppingCart/actions';
import {
  Footer,
  FooterCol,
  FooterTitle,
  Header,
  ImageContainer,
  ListItem,
  ValueText,
} from './styles';
import { baseURL } from '../../services/api';
import defaultImg from '../../assets/img/default.jpg';
import Swal from 'sweetalert2';
import { useWindowSize } from '../../customHooks';
import PromoTag from '../PromoTag';
import { colors } from '../../utils/constants';
const { Panel } = Collapse;
const MetreageItem: React.FC<ShoppingCartItem> = (item) => {
  const layout = useSelector((state: ApplicationState) => state.layout.data);
  const { currentAction, currentActionItemId, config } = useSelector((state: ApplicationState) => state.shoppingCart);
  const dispatch = useDispatch<Dispatch<Action>>();
  const size = useWindowSize();
  const deleteAction = () => {
    Swal.fire({
      title: 'Atenção!',
      text: `Deseja deletar o item do carrinho?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: layout?.color.default,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) dispatch(deleteItemRequest(item));
    });
  };

  const getActions = () => {
    return (size.width || 0) > 550
      ? [
        <ValueText>
          {maskCurrency((item.value || 0) * ((item.quantity || 0) * (item.multiplier || 1)))}
        </ValueText>,
        <Tooltip placement="left" title="Remover item">
          {
            currentActionItemId === item.codProd && currentAction === 'REMOVE' ? <LoadingOutlined /> :
              <DeleteFilled onClick={deleteAction} style={{ fontSize: '16px', color: 'red' }} />
          }
        </Tooltip>,
      ]
      : [];
  };

  const deleteItem = (element: Metreage) => {
    if (item.metreages?.length === 0) {
      dispatch(
        deleteItemRequest({
          codProd: item.codProd,
          unity: item.unity,
          quantity: 0,
          metreages: item.metreages,
          description: item.description,
          value: item.value,
        })
      );
    } else {
      const newQuantities = item.metreages?.filter(({ size }) => size !== element.size);
      if (newQuantities?.length === 0) {
        dispatch(
          deleteItemRequest({
            codProd: item.codProd,
            unity: item.unity,
            quantity:
              (newQuantities?.reduce((total, { quantity }) => total + quantity, 0) || 0) *
              parseFloat(
                (newQuantities?.reduce((total, e) => total + e.size * e.quantity, 0) || 0).toFixed(
                  2
                )
              ),
            metreages: newQuantities,
            description: item.description,
            value: item.value,
          })
        );
      } else {
        dispatch(
          addItemRequest({
            unity: item.unity,
            codProd: item.codProd,
            quantity:
              (newQuantities?.reduce((total, { quantity }) => total + quantity, 0) || 0) *
              parseFloat(
                (newQuantities?.reduce((total, e) => total + e.size * e.quantity, 0) || 0).toFixed(
                  2
                )
              ),
            metreages: newQuantities,
            description: item.description,
            value: item.value,
            controlType: item.controlType
          })
        );
      }
    }
  };
  return (
    <Header>
      <Collapse ghost expandIcon={() => <></>}>
        <Panel
          key={item.codProd || 0}
          header={
            <ListItem>
              <List.Item
                extra={
                  (size.width || 0) <= 550 ? (
                    <Row gutter={[10, 10]} align="middle" justify="space-between">
                      <Col>
                        <ValueText>
                          {maskCurrency(
                            (item.value || 0) * ((item.quantity || 0) * (item.multiplier || 1))
                          )}
                        </ValueText>
                      </Col>
                      <Col>
                        <Tooltip placement="left" title="Remover item">
                          {
                            currentActionItemId === item.codProd && currentAction === 'REMOVE' ? <LoadingOutlined /> :
                              <DeleteFilled onClick={deleteAction} style={{ fontSize: '16px', color: 'red' }} />
                          }
                        </Tooltip>
                      </Col>
                    </Row>
                  ) : undefined
                }
                actions={getActions()}
              >
                <List.Item.Meta
                  title={<h3>{item.description}</h3>}
                  avatar={
                    config?.details.viewModes.some(
                      (mode: string) => mode === 'CARD' || mode === 'LIST'
                    ) && (
                      <ImageContainer>
                        <Image
                          preview={false}
                          fallback={defaultImg}
                          loading="lazy"
                          placeholder={
                            <Spin
                              indicator={
                                <LoadingOutlined style={{ color: layout?.color.default }} />
                              }
                            />
                          }
                          style={{ maxHeight: '100%', maxWidth: '100%' }}
                          src={`${baseURL}/produtos/${item?.codProd}/imagem?w=50&h=50`}
                        />
                      </ImageContainer>
                    )
                  }
                  description={
                    <Row gutter={[5, 5]}>
                      {item.isPromo && (
                        <Col span={24}>
                          <PromoTag />
                        </Col>
                      )}
                      <Col span={24}>
                        <div>
                          {maskCurrency(item.value || 0)} {item.value ? '/' : ''}
                          {maskCamelCase(item.unity?.value || '')}
                        </div>
                        <div>
                          {item.message && (
                            <small style={{ color: colors.danger }}>{item.message}</small>
                          )}
                        </div>
                      </Col>
                    </Row>
                  }
                />
              </List.Item>
            </ListItem>
          }
        >
          {item.metreages &&
            item.metreages.map((element, _index) => {
              return (
                <>
                  <Row>
                    <Col span={16}>
                      <>
                        Quantidade: <strong>{element.quantity}</strong>
                      </>
                      <br />
                      <>
                        Comprimento:{' '}
                        <strong>
                          {element.size} {element.size === 1 ? 'metro' : 'metros'}
                        </strong>
                      </>
                    </Col>
                    <Col
                      span={6}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        color: 'green',
                      }}
                    >
                      <strong>
                        {maskCurrency(
                          (item.value || 0) * ((element.quantity || 0) * (element.size || 1))
                        )}
                      </strong>
                    </Col>
                    <Col
                      span={2}
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                    >
                      <Tooltip placement="left" title="Remover item">
                        <h3
                          style={{ margin: 0 }}
                          className="remove-item"
                        >
                          {
                            currentActionItemId === item.codProd && currentAction === 'REMOVE' ? <LoadingOutlined /> :
                              <DeleteFilled
                                onClick={() => {
                                  deleteItem(element);
                                }}
                                style={{ color: 'red', cursor: 'pointer', padding: '0 8px' }}
                              />
                          }
                        </h3>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Divider style={{ margin: '12px 0' }} />
                </>
              );
            })}
          <Footer>
            <FooterCol>
              <FooterTitle>QTD TOTAL</FooterTitle>
              <strong>
                {item.metreages &&
                  item.metreages.reduce((total, item) => total + item.quantity, 0).toFixed(2)}
              </strong>
            </FooterCol>
            <FooterCol>
              <small>COMPRIMENTO TOTAL</small>
              <strong>
                {item.metreages &&
                  item.metreages
                    .reduce((total, item) => total + item.size * item.quantity, 0)
                    .toFixed(2)}
                {item.metreages &&
                  parseFloat(
                    item.metreages
                      .reduce((total, item) => total + item.size * item.quantity, 0)
                      .toFixed(2)
                  ) === 1
                  ? ' metro'
                  : ' metros'}
              </strong>
            </FooterCol>
          </Footer>
        </Panel>
      </Collapse>
      <Divider style={{ margin: 0 }} />
    </Header>
  );
};

export default MetreageItem;
